var addZoom = (target) => {
  // (A) GET CONTAINER + IMAGE SOURCE
  let container = document.getElementById(target),
      imgsrc = container.currentStyle || window.getComputedStyle(container, false);
      imgsrc = imgsrc.backgroundImage.slice(4, -1).replace(/"/g, "");
 
  // (B) LOAD IMAGE + ATTACH ZOOM
  let img = new Image();
  img.src = imgsrc;
  img.onload = () => {
    // (B1) CALCULATE ZOOM RATIO
    let ratio = img.naturalHeight / img.naturalWidth,
        percentage = ratio * 100 + "%";
 
    // (B2) ATTACH ZOOM ON MOUSE MOVE
    container.onmousemove = (e) => {
      let rect = e.target.getBoundingClientRect(),
          xPos = e.clientX - rect.left,
          yPos = e.clientY - rect.top,
          xPercent = xPos / (container.clientWidth / 100) + "%",
          yPercent = yPos / ((container.clientWidth * ratio) / 100) + "%";
 
      Object.assign(container.style, {
        backgroundPosition: xPercent + " " + yPercent,
        backgroundSize: img.naturalWidth + "px"
      });
    };
 
    // (B3) RESET ZOOM ON MOUSE LEAVE
    container.onmouseleave = (e) => {
      Object.assign(container.style, {
        backgroundPosition: "center",
        backgroundSize: "cover"
      });
    };
  }
};
 
// (C) ATTACH FOLLOW ZOOM
	
  	addZoom("zoomImg");

$(".product-detail__big-image").hover(function(){
    if($(".product-detail__big-image #zoomArea.video-tag-pdp .product-detail--main-image").hasClass("product-detail--hide")){
        $(this).find("#zoomImg").css("opacity", "1");
        $(this).find("#zoomImg").css("pointer-events", "auto");
    }
}, function(){
    $(this).find("#zoomImg").css("opacity", "0");
    $(this).find("#zoomImg").css("pointer-events", "none");
});
	


function imagenum_click(event){
	number = (event.target.parentElement.querySelector('input[name="thumbnailsImages"]').value) - 1;
	document.getElementById("zoomImg").style.background = "url('" + document.getElementsByClassName("product-detail__big-image")[0].childNodes[number].getElementsByClassName("product-detail--main-image")[0].src + "')";
}
